// extracted by css-extract-rspack-plugin
export default {"hero":"HeroContentNext-module__hero__Ouh668S","buttons":"HeroContentNext-module__buttons__D6_za5s"};